<template>
    <div class="user">

        <div class="common-seach-wrap">
<!--            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">-->
<!--                <el-form-item label="标题">-->
<!--                    <el-input v-model="query.keyword" placeholder="请输入标题" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="类型">-->
<!--                    <el-select v-model="query.course_type" placeholder="全部" clearable>-->
<!--                        <el-option v-for="(item, index) in select_type_array" :label="item" :value="index" :key="index"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="创建时间">-->
<!--                    <div class="block">-->
<!--                        <span class="demonstration"></span>-->
<!--                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->
<!--                    </div>-->
<!--                </el-form-item>-->

<!--                <el-form-item>-->
<!--                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
        </div>
        <!--添加等级-->
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/vote/cmpeAdd'">添加参赛者</el-button>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="vote_id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="" label="图片" width="100">
                        <template slot-scope="scope">
                            <el-image style="height: 40px" fit="contain" v-if="scope.row.file_path" class="ya-img-table" :src="scope.row.file_path"
                                      :preview-src-list="[scope.row.file_path]" title="点击查看大图" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_vote_num" label="总投票次数" width="90"></el-table-column>
                    <el-table-column prop="total_user_num" label="总参与人数" width="90"></el-table-column>
                    <el-table-column prop="total_user_num" label="投票规则" width="250">
                        <template slot-scope="scope">
                            {{  '每个微信号码每天可投 '+ scope.row.user_max_num +' 票' }} <br>
                            {{  '每个微信号码每天可为同一选手投 '+ scope.row.cmpe_max_num + ' 票' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status_desc" label="状态" width="100"></el-table-column>
                    <el-table-column prop="is_show_desc" label="显示/隐藏" width="100"></el-table-column>
                    <el-table-column prop="sort" label="排序" width="60"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleCmpe(scope.row)" type="text" size="small" v-auth="'/education/vote/cmpeList'">选手作品</el-button>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/vote/cmpeEdit'">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/vote/cmpeDel'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
        <edit ref="edit" @fetch-data="refresh"></edit>
    </div>
</template>

<script>
    import { voteList, voteDel } from '@/api/education';
    import Edit from './edit.vue';

    export default {
        components: {
            /*编辑组件*/
            Edit,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    status: '',
                    is_show: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                voteList(this.query).then((result)=>{
                    this.loading = false
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 添加
            handleAdd(){
                this.$refs['edit'].showDialog()
            },
            // 编辑
            handleEdit(row) {
                this.$refs['edit'].showDialog(row)
            },
            // 作品管理
            handleCmpe(row){
                this.$router.push({
                    path: '/education/vote/vote/cmpe',
                    query: {
                        vote_id: row.vote_id,
                        scene: 'list'
                    }
                });
            },
            // 删除
            handleDelete(row) {
                if (row.vote_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        voteDel({ids: row.vote_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.course_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/vote/cmpe/index.vue